<template>
  <v-layout row align-center justify-center class="wrap">
    <v-flex xs12 sm3 md4>
      <v-card class="elevation-12">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-text-field
            prepend-inner-icon="mdi-account"
            name="login"
            label="Login"
            type="text"
            v-model="user.username"
            :outlined="outlinedInputs"
          ></v-text-field>
          <v-text-field
            prepend-inner-icon="mdi-lock"
            name="password"
            label="Password"
            id="password"
            type="password"
            v-model="user.password"
            @keyup.enter="onLoginClick"
            :outlined="outlinedInputs"
          ></v-text-field>

          <v-text-field
            v-if="twoFaRequired"
            prepend-inner-icon="mdi-lock"
            name="2fa"
            label="2FA Code"
            type="text"
            v-model="twoFaCode"
            :outlined="outlinedInputs"
            @keyup.enter="onLoginClick"
          ></v-text-field>

          <v-alert type="error" :value="error" transition="scale-transition">{{
            errorMessage
          }}</v-alert>
          <v-alert type="info" :value="info" transition="scale-transition"
            >{{ infoMessage }}

            <v-btn
              small
              color="white"
              text
              @click.prevent="check2fa"
              outlined
              :loading="checking2fa"
              >Resend</v-btn
            >
          </v-alert>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-btn
            text
            to="/reset-password"
            small
            color="primary"
            v-if="showResetPassword"
          >
            FORGOT/RESET PASSWORD
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.prevent="onLoginClick">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import gql from "graphql-tag";
import { apolloClient } from "../../constants/apollo-provider";

import { SIGNIN_USER_MUTATION } from "../../constants/graphql";
import { GT_LOGIN_LABEL } from "../../constants/settings";
const CHECK_2FA_MUTATION = gql`
  mutation check2FA($username: String!, $password: String!) {
    check2FA(username: $username, password: $password) {
      success
      message
    }
  }
`;
export default {
  data: () => ({
    user: {
      username: "",
      password: "",
    },
    error: false,
    errorMessage: "",
    twoFaRequired: false,
    info: false,
    infoMessage: "",
    twoFaCode: "",
    checking2fa: false,
  }),
  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    auth() {
      return this.$store.getters.isAuthenticated;
    },
    title() {
      return GT_LOGIN_LABEL;
    },
    showResetPassword() {
      // const hideResetPasswordDomains = [
      //   "cpstest.pinkelephantinternational.com",
      //   "cpslive.pinkelephantinternational.com",
      // ];
      // return !hideResetPasswordDomains.includes(window.location.hostname);
      return true;
    },
  },
  methods: {
    onLoginClick() {
      if (this.twoFaRequired) {
        this.login();
      } else {
        this.check2fa();
      }
    },
    check2fa() {
      this.checking2fa = true;
      this.$apollo
        .mutate({
          mutation: CHECK_2FA_MUTATION,
          variables: {
            username: this.user.username,
            password: this.user.password,
          },
        })
        .then((result) => {
          this.checking2fa = false;
          if (result.data.check2FA.success) {
            this.twoFaRequired = true;
            this.infoMessage = result.data.check2FA.message;
            this.info = true;
          } else {
            // No 2FA required
            this.login();
          }
        })
        .catch((error) => {
          // Error
          console.error(error);
          this.checking2fa = false;
          if (error.graphQLErrors.length) {
            this.errorMessage = error.graphQLErrors[0].message;
          } else {
            this.errorMessage = error;
          }
          this.error = true;
        });
    },
    async login() {
      apolloClient.cache.reset();
      this.$apollo
        .mutate({
          mutation: SIGNIN_USER_MUTATION,
          variables: {
            username: this.user.username,
            pass: this.user.password,
            twoFaCode: this.twoFaCode,
          },
        })
        .then((result) => {
          this.$store.dispatch("storeUser", result.data.signInUser);
          this.$router.push({ path: "/home" });
        })
        .catch((error) => {
          // Error
          console.error(error);
          if (error.graphQLErrors.length) {
            this.errorMessage = error.graphQLErrors[0].message;
          } else {
            this.errorMessage = error;
          }
          this.error = true;
        });
    },
  },
};
</script>
<style scoped>
.wrap {
  background: linear-gradient(to right top, #1867c0, #19e5f4);
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LoginPage.vue